module.exports = "pegasus/assets/circle-facebook.png";